import { render } from "./KBListScreen.vue?vue&type=template&id=0280092b&scoped=true"
import script from "./KBListScreen.vue?vue&type=script&lang=js"
export * from "./KBListScreen.vue?vue&type=script&lang=js"

import "./KBListScreen.vue?vue&type=style&index=0&id=0280092b&scoped=true&lang=scss"

import exportComponent from "/builds/cloud/messenger/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0280092b"]])

export default __exports__